export default __webpack_public_path__ + "static/media/img-2.d318de83.jpg";